import React from 'react'
import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

export const useAccountSubscriptionPortalMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/c/createAndLaunchPortal',
    method: 'POST'
  })
}
